"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BusSideSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M8 19a4 4 0 104 4 4 4 0 00-4-4zm0 6a2 2 0 112-2 2 2 0 01-2 2zM23 19a4 4 0 104 4 4 4 0 00-4-4zm0 6a2 2 0 112-2 2 2 0 01-2 2z"/><path d="M29 5H3a2 2 0 00-2 2v15a2 2 0 002 2h3.3a2.4 2.4 0 01-.2-.4.6.6 0 000-.1 1.8 1.8 0 010-1 2.4 2.4 0 01.2-.5 2 2 0 013.4 0 2.4 2.4 0 01.2.4.6.6 0 000 .1 1.8 1.8 0 010 1 2.4 2.4 0 01-.2.5h11.6a2.4 2.4 0 01-.2-.4.6.6 0 000-.1 1.8 1.8 0 010-1 2.4 2.4 0 01.2-.5 2 2 0 013.4 0 2.4 2.4 0 01.2.4.6.6 0 000 .1 1.8 1.8 0 010 1 2.4 2.4 0 01-.2.5H29a2 2 0 002-2V7a2 2 0 00-2-2zm-10 7H3V7h16zm10 0h-8V7h8z"/>';
var BusSideSVG = function BusSideSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.BusSideSVG = BusSideSVG;
BusSideSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(BusSideSVG);
exports.default = _default;